import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#101010",
  stroke: "#fff",
  "stroke-width": ".3",
  d: "M9.167 2.65h1.666a1.517 1.517 0 0 1 1.517 1.517V7.65h3.483a1.517 1.517 0 0 1 1.517 1.517v1.666a1.517 1.517 0 0 1-1.517 1.517H12.35v3.483a1.517 1.517 0 0 1-1.517 1.517H9.167a1.517 1.517 0 0 1-1.517-1.517V12.35H4.167a1.517 1.517 0 0 1-1.517-1.517V9.167A1.52 1.52 0 0 1 4.167 7.65H7.65V4.167A1.52 1.52 0 0 1 9.167 2.65Zm-.15 5.683a.684.684 0 0 1-.684.684H4.017v1.966h4.316a.684.684 0 0 1 .684.684v4.316h1.966v-4.316a.684.684 0 0 1 .684-.684h4.316V9.017h-4.316a.684.684 0 0 1-.684-.684V4.017H9.017z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }